import { render, staticRenderFns } from "./VehicleAttributesForm.vue?vue&type=template&id=91723762&"
import script from "./VehicleAttributesForm.vue?vue&type=script&lang=js&"
export * from "./VehicleAttributesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91723762')) {
      api.createRecord('91723762', component.options)
    } else {
      api.reload('91723762', component.options)
    }
    module.hot.accept("./VehicleAttributesForm.vue?vue&type=template&id=91723762&", function () {
      api.rerender('91723762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Forms/VehicleAttributesForm.vue"
export default component.exports